module.exports = "<div class='sub_title'>\n  보너스 카드\n</div>\n\n<div class='bonus_content'>\n  <img src=\"assets/page/bonus_card.jpg\">\n</div>\n"